import { maintenancePlanList } from '@/api/serviceAPi'
import config from '../config'
import { limitMoreZero } from '@/utils/validate'
import { operateMaxShowLength } from '@/store/dict/config'

const { planState } = config
export default {
  data() {
    return {
      configData: {
        formData: {
          list: [
            {
              el: 'input',
              itemConfig: {
                label: '方案ID',
                prop: 'id',
              },
              elConfig: {
                maxlength: 18,
                events: {
                  input: this.limitNumber,
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '维修厂名称',
                prop: 'providerId',
              },
              elConfig: {
                options: {
                  label: 'name',
                  value: 'id',
                  list: [],
                },
              },
            },
            {
              el: 'select',
              itemConfig: {
                label: '方案状态',
                prop: 'state',
              },
              elConfig: {
                options: {
                  label: 'label',
                  value: 'value',
                  list: planState,
                },
              },
            },
          ],
        },
        tableData: {
          columns: [
            {
              name: 'id',
              columnProps: {
                label: '方案ID',
                prop: 'id',
              },
            },
            {
              name: 'name',
              columnProps: {
                label: '方案名称',
                prop: 'name',
                width: '160px',
              },
            },
            {
              name: 'providerName',
              columnProps: {
                label: '维修厂名称',
                prop: 'providerName',
              },
            },
            {
              name: 'createDate',
              columnProps: {
                label: '创建时间',
                prop: 'createDate',
              },
            },
            {
              name: 'state',
              columnProps: {
                label: '方案状态',
                prop: 'state',
              },
              render: ({ row }) => {
                const { state } = row
                const planItem = planState.find((item) => Number(item.value) === Number(state))
                return planItem?.label || '--'
              },
            },
            {
              name: 'operate',
              columnProps: {
                label: '操作',
                width: 240,
              },
              maxShowLength: operateMaxShowLength,
              getOperateList: ({ row }) => {
                const optBtns = []
                if (this.judgePermission('maintenance_plan_detail_temp')) {
                  optBtns.push({
                    name: 'detail',
                    label: '详情',
                    action: () => this.detailHandle(row),
                  })
                }
                return optBtns
              },
              type: 'operate',
            },
          ],
          pagination: {
            pageSizes: [10, 20, 30, 50],
          },
          apiFn: maintenancePlanList,
        },
      },

      planConfigData: {
        tableData: {
          columns: [
            {
              name: 'photo',
              columnProps: {
                label: '商品图片',
              },
              render: ({ row }) => {
                const { photo } = row
                return this.$createElement('el-image', {
                  style: 'width: 60px; height: 60px',
                  props: {
                    src: photo,
                    'preview-src-list': [photo],
                  },
                })
              },
            },
            {
              name: 'goodsName',
              columnProps: {
                label: '商品信息',
              },
              render: ({ row }) => {
                const { goodsName, goodsSpecs } = row
                return this.$createElement('div', {
                  style: 'display:flex;flex-direction:column',
                }, [
                  this.$createElement('span', goodsName),
                  this.$createElement('span', { style: 'color:#909399' }, goodsSpecs),
                ])
              },
            },
            {
              name: 'packagePrice',
              columnProps: {
                label: '单价（元）',
              },
              render: ({ row }) => {
                const { packagePrice, originPrice } = row
                return this.$createElement('div', {
                  style: 'display:flex;flex-direction:column',
                }, [
                  this.$createElement('span', packagePrice),
                  this.$createElement('span', { style: 'text-decoration: line-through;color:#909399' }, originPrice),
                ])
              },
            },
            {
              name: 'goodsNum',
              columnProps: {
                label: '数量',
                prop: 'goodsNum',
              },
            },
            {
              name: 'sumPrice',
              columnProps: {
                label: '金额（元）',
                prop: 'sumPrice',
              },
            },
            {
              name: 'workAmount',
              columnProps: {
                label: '工时费（元）',
                prop: 'workAmount',
                align: 'center',
              },
              render: ({ row }) => {
                return row.workAmount || '--'
              },
            },
          ],
        },
      },
    }
  },
  methods: {
    limitNumber(value) {
      limitMoreZero(value, (val) => {
        this.$set(this.configData.formData.formProps.model, 'id', val)
      }, 9, false)
    },
  },
}
